import React, { createContext, useState, useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FetchContext } from "./FetchContext";

const AuthContext = createContext();
const { Provider } = AuthContext;

const AuthProvider = ({ children }) => {
  const history = useNavigate();
  const fetchContext = useContext(FetchContext);

  const [authState, setAuthState] = useState({
    userInfo: null,
    isAuthenticated: null,
  });

  const location = useLocation();
const publicRoutes = ["/login", "/forgotpassword", "/register"]; // Add more if needed


useEffect(() => {
  // don't call /user on public routes (prevents the 401 XHR showing in console)
  if (publicRoutes.includes(location.pathname)) {
    // ensure state reflects unauthenticated on public pages
    setAuthState({
      userInfo: {},
      isAuthenticated: false,
    });
    return;
  }

  const getUserInfo = async () => {
    try {
      const { data } = await fetchContext.authAxios.get("/user");

      setAuthState({
        userInfo: data,
        isAuthenticated: true,
      });
    } catch (err) {
      // silently handle auth errors and set unauthenticated state
      setAuthState({
        userInfo: {},
        isAuthenticated: false,
      });

      // redirect only if not on a public page
      if (!publicRoutes.includes(location.pathname)) {
        history("/login");
      }
    }
  };

  getUserInfo();
  // console.log("Auth useEffect - location.pathname:", location.pathname);
}, [fetchContext, location.pathname, history]);


  const setAuthInfo = ({ userInfo }) => {
    setAuthState({
      userInfo,
      isAuthenticated: userInfo ? true : false,
    });
  };

  const logout = async () => {
    try {
      await fetchContext.publicAxios.post("/logout");

      setAuthState({
        userInfo: {},
        isAuthenticated: false,
      });
      history("/");
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Provider
      value={{
        authState,
        setAuthState: (authInfo) => setAuthInfo(authInfo),
        logout, 
      }}
    >
      {children}
    </Provider>
  );
};

export { AuthContext, AuthProvider };
